// extracted by mini-css-extract-plugin
export default {"result":"TestQuestions_result__TaZ3P"};